export const commonDtOptions = {
  pagingType: 'simple_numbers',
  serverSide: true,
  processing: true,
  buttons: ['csv', 'print', 'excel'],
  dom: 'Blfrtip',
  ordering: false,
  lengthChange: true,
  pageLength: 10,
  lengthMenu: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 240, 280, 300, 400, 500],
};

export const auctionTheads = [
  // 'Select',
  'Photo',
  'Make',
  'Model',
  'Trim/Type',
  'Rating',
  'Price',
  'Model Year',
  'VIN',
  'Registration',
  'ODO',
  'Added In',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
  'Accleration',
  'Assessment Type',
  'Body Type',
  'COD',
  'Condition',
  'Cylinders',
  'Doors',
  'Drive Type',
  'Engine Type',
  'Estimara',
  'Estimara expiry date',
  'Finance Status',
  'Fuel Type',
  'HP (Horse Power)',
  'Last service date',
  'MVPI expiry date',
  'Max Speed',
  'Mileage',
  'Origin',
  'Seat',
  'Service and maintenance status',
  'Torque',
  'Transmission Type',
  'Upholstery',
  'Utility Type',
  'Vehicle Type',
  'Vendor',
  'Warranty',
  'Warranty expiry date',
  'Wheel Base',
  'Location',
  'Action',
];

export const auctionColumns = [
  // {
  //   title: '<input type="checkbox" class="select-all-checkbox" id="select-all" style="cursor: pointer">',
  //   data: null,
  //   orderable: false,
  //   render: (data: object) => {
  //     return `<input type="checkbox" class="row-checkbox p-0 m-0" style="cursor: pointer" id=${data?.['Actions']?.['productId']}>`;
  //   },
  // },
  {
    title: 'Photo',
    data: 'Photo',
    render: (data) => {
      return `<img src="${data}" style="width: 6rem; height: auto;"/>`;
    },
  },
  { title: 'Make', data: 'Make' },
  { title: 'Model', data: 'Model' },
  { title: 'Trim/Type', data: 'Trim/Type' },
  { title: 'Rating', data: 'Rating' },
  { title: 'Price', data: 'Price' },
  { title: 'Model Year', data: 'Model Year' },
  { title: 'VIN', data: 'VIN' },
  { title: 'Registration', data: 'Registration' },
  { title: 'ODO', data: 'ODO' },
  {
    title: 'Added In',
    data: 'Added In',
    render: (data) => {
      if (typeof data === 'string' && data.length > 0) {
        return data.charAt(0).toUpperCase() + data.slice(1).toLowerCase();
      }

      return data;
    },
  },
  { title: 'Exterior Colour', data: 'Exterior Colour' },
  { title: 'Interior Colour', data: 'Interior Colour' },
  { title: 'Engine CC', data: 'Engine CC' },
  { title: 'Gears', data: 'Gears' },
  { title: 'Accleration', data: 'Accleration' },
  { title: 'Assessment Type', data: 'Assessment Type' },
  { title: 'Body Type', data: 'Body Type' },
  { title: 'COD', data: 'COD' },
  { title: 'Condition', data: 'Condition' },
  { title: 'Cylinders', data: 'Cylinders' },
  { title: 'Doors', data: 'Doors' },
  { title: 'Drive Type', data: 'Drive Type' },
  { title: 'Engine Type', data: 'Engine Type' },
  { title: 'Estimara', data: 'Estimara' },
  { title: 'Estimara expiry date', data: 'Estimara expiry date' },
  { title: 'Finance Status', data: 'Finance Status' },
  { title: 'Fuel Type', data: 'Fuel Type' },
  { title: 'HP (Horse Power)', data: 'HP (Horse Power)' },
  { title: 'Last service date', data: 'Last service date' },
  { title: 'MVPI expiry date', data: 'MVPI expiry date' },
  { title: 'Max Speed', data: 'Max Speed' },
  { title: 'Mileage', data: 'Mileage' },
  { title: 'Origin', data: 'Origin' },
  { title: 'Seat', data: 'Seat' },
  {
    title: 'Service and maintenance status',
    data: 'Service and maintenance status',
  },
  { title: 'Torque', data: 'Torque' },
  { title: 'Transmission Type', data: 'Transmission Type' },
  { title: 'Upholstery', data: 'Upholstery' },
  { title: 'Utility Type', data: 'Utility Type' },
  { title: 'Vehicle Type', data: 'Vehicle Type' },
  { title: 'Vendor', data: 'Vendor' },
  { title: 'Warranty', data: 'Warranty' },
  { title: 'Warranty expiry date', data: 'Warranty expiry date' },
  { title: 'Wheel Base', data: 'Wheel Base' },
  { title: 'Location', data: 'Location' },
  {
    title: 'Actions',
    data: 'Actions',
    width: '160px',
    render: (data) => {
      const { productId, productName, status, addedIn } = data || {};
      const isBatch = addedIn === 'batch';
      const isPlayDisabled = status === 'Play';
      const isPauseStopDisabled = ['Pause', 'Stop', null].includes(status);

      const renderButton = (type, icon, additionalAttrs = '', isDisabled = false, color = 'yellow') => {
        return `
          <button class="m-0 p-1 ${type}-btn" data-product-name="${productName}" data-product-id="${productId}" ${
          isDisabled ? 'disabled' : ''
        } style="opacity: ${isDisabled ? 0.5 : 1}; cursor: ${isDisabled ? 'not-allowed' : 'pointer'}" ${additionalAttrs}>
            <ion-icon name="${icon}" class="color-${color}" style="font-size: 25px"></ion-icon>
          </button>
        `;
      };

      return `
        <div class="d-flex actions-btn">
          ${renderButton('view', 'eye', `data-product-id="${productId}" title="View"`)}
          ${
            !isBatch
              ? `
            ${renderButton('play', 'play-circle-outline', `title="Play"`, isPlayDisabled)}
            ${renderButton('pause', 'pause-circle-outline', `title="Pause"`, isPauseStopDisabled)}
            ${renderButton('stop', 'stop-circle-outline', `title="Stop"`, isPauseStopDisabled, 'red')}
          `
              : ''
          }
        </div>
      `;
    },
  },
];

export const batchTheads = ['Photo', 'Batch id', 'Batch name', 'Location', 'Number Of vehicles', 'Action'];

export const batchColumns = [
  {
    title: 'Photo',
    data: 'Photo',
    render: (data) => {
      return `<img src="${data}" style="width: 6rem; height: auto;"/>`;
    },
  },
  { title: 'Batch id', data: 'Batch id' },
  { title: 'Batch name', data: 'Batch name' },
  { title: 'Location', data: 'Location' },
  { title: 'Number of vehicles', data: 'Number of vehicles' },
  {
    title: 'Action',
    data: 'Action',
    render: (data) => {
      return `<div style="display: flex; gap: 0.5rem;">
      <button type="button" class="btn btn__util view-btn" data-product-id="${data}">
        <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
      </button>
      <button type="button" class="btn btn__util color-yellow edit-btn" data-product-id="${data}">
        <i class="las la-pen ion-2x"></i>
      </button>
      <button type="button" class="btn btn__util delete-btn" data-product-id="${data}">
        <ion-icon name="trash-outline" class="ion-lg color-red"></ion-icon>
      </button>
    </div>`;
    },
  },
];

export const soldIndividualTheads = [
  'Photo',
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN',
  'Registration',
  'ODO',
  'Auction Type',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
  'Reserved Price',
  'Buy now Price',
  'Accleration',
  'Assessment Type',
  'Body Type',
  'COD',
  'Condition',
  'Cylinders',
  'Doors',
  'Drive Type',
  'Engine Type',
  'Estimara',
  'Estimara expiry date',
  'Finance Status',
  'Fuel Type',
  'HP (Horse Power)',
  'Last service date',
  'MVPI expiry date',
  'Max Speed',
  'Mileage',
  'Origin',
  'Seat',
  'Service and maintenance status',
  'Torque',
  'Transmission Type',
  'Upholstery',
  'Utility Type',
  'Vehicle Type',
  'Vendor',
  'Warranty',
  'Warranty expiry date',
  'Wheel Base',
  'Location',
  'Action',
];

export const soldIndividualColumns = [
  {
    title: 'Photo',
    data: 'Photo',
    render: (data) => {
      return `<img src="${data}" style="width: 6rem; height: auto;"/>`;
    },
  },
  { title: 'Make', data: 'Make' },
  { title: 'Model', data: 'Model' },
  { title: 'Trim/Type', data: 'Trim/Type' },
  { title: 'Model Year', data: 'Model Year' },
  { title: 'VIN', data: 'VIN' },
  { title: 'Registration', data: 'Registration' },
  { title: 'ODO', data: 'ODO' },
  { title: 'Auction Type', data: 'Auction Type' },
  { title: 'Exterior Colour', data: 'Exterior Colour' },
  { title: 'Interior Colour', data: 'Interior Colour' },
  { title: 'Engine CC', data: 'Engine CC' },
  { title: 'Gears', data: 'Gears' },
  { title: 'Reserved Price', data: 'Reserved Price' },
  { title: 'Buy now Price', data: 'Buy now Price' },
  { title: 'Accleration', data: 'Accleration' },
  { title: 'Assessment Type', data: 'Assessment Type' },
  { title: 'Body Type', data: 'Body Type' },
  { title: 'COD', data: 'COD' },
  { title: 'Condition', data: 'Condition' },
  { title: 'Cylinders', data: 'Cylinders' },
  { title: 'Doors', data: 'Doors' },
  { title: 'Drive Type', data: 'Drive Type' },
  { title: 'Engine Type', data: 'Engine Type' },
  { title: 'Estimara', data: 'Estimara' },
  { title: 'Estimara expiry date', data: 'Estimara expiry date' },
  { title: 'Finance Status', data: 'Finance Status' },
  { title: 'Fuel Type', data: 'Fuel Type' },
  { title: 'HP (Horse Power)', data: 'HP (Horse Power)' },
  { title: 'Last service date', data: 'Last service date' },
  { title: 'MVPI expiry date', data: 'MVPI expiry date' },
  { title: 'Max Speed', data: 'Max Speed' },
  { title: 'Mileage', data: 'Mileage' },
  { title: 'Origin', data: 'Origin' },
  { title: 'Seat', data: 'Seat' },
  {
    title: 'Service and maintenance status',
    data: 'Service and maintenance status',
  },
  { title: 'Torque', data: 'Torque' },
  { title: 'Transmission Type', data: 'Transmission Type' },
  { title: 'Upholstery', data: 'Upholstery' },
  { title: 'Utility Type', data: 'Utility Type' },
  { title: 'Vehicle Type', data: 'Vehicle Type' },
  { title: 'Vendor', data: 'Vendor' },
  { title: 'Warranty', data: 'Warranty' },
  { title: 'Warranty expiry date', data: 'Warranty expiry date' },
  { title: 'Wheel Base', data: 'Wheel Base' },
  { title: 'Location', data: 'Location' },
  {
    title: 'Action',
    data: 'Action',
    render: (data) => {
      return `<button type="button" class="btn btn__util view-btn" data-product-id="${data}">
      <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
    </button>`;
    },
  },
];

export const soldBulkTheads = [
  'Photo',
  'Title',
  'Total number of vehicles',
  'Opening price',
  'Reserved price',
  'Buy now price',
  'Recycle times',
  'Location',
  'Action',
];

export const soldBulkColumns = [
  {
    title: 'Photo',
    data: 'Photo',
    render: (data) => {
      return `<img src="${data}" style="width: 6rem; height: auto;"/>`;
    },
  },
  { title: 'Title', data: 'Title' },
  { title: 'Total number of vehicles', data: 'Total number of vehicles' },
  { title: 'Opening price', data: 'Opening price' },
  { title: 'Reserved price', data: 'Reserved price' },
  { title: 'Buy now price', data: 'Buy now price' },
  { title: 'Recycle times', data: 'Recycle times' },
  { title: 'Location', data: 'Location' },
  {
    title: 'Action',
    data: 'Action',
    render: (data) => {
      return `<button type="button" class="btn btn__util view-btn" data-product-id="${data}">
    <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
  </button>`;
    },
  },
];

export const searchElement = [
  'Make',
  'Model',
  'Model Year',
  'Body Type',
  'Trim/Type',
  'Exterior Colour',
  'VIN Number',
  'Plate Number',
];
